<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import AppIcon from '@/components/common/AppIcon.vue'
import { useClock } from '@/composables/useClock'
import { useUserStore } from '@/stores/user'

/**
 * 24-hour clock in the user's timezone (`getUser().timezone`), falling back to
 * Europe/London (the game server time) when the account has none.
 */
const { t } = useI18n()
const user = useUserStore()

const timeZone = computed(() => user.timeZone)
const { time, label } = useClock(timeZone)
</script>

<template>
  <div
    class="text-parchment-100 hidden items-center gap-2 rounded-md border border-white/10 bg-black/20 px-2.5 py-1.5 sm:flex"
    :title="t('header.clock.timezone', { zone: label })"
  >
    <AppIcon name="mdi-clock-outline" class="text-gold-300 text-base" />
    <!-- aria-live off on purpose: a clock announcing every second is hostile
         to screen-reader users. The label below gives the context on demand. -->
    <time class="font-mono text-sm tabular-nums" :aria-label="t('header.clock.label')">
      {{ time }}
    </time>
    <span class="text-parchment-300 hidden text-[0.65rem] tracking-wide lg:inline">
      {{ label }}
    </span>
  </div>
</template>
